import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../environment/environment';
import { Observable } from 'rxjs';
import { ExportAvanzatoEsportazioneDto, ExportAvanzatoFilters, ExportAvanzatoListDto, FiltriAvanzatiExportDropdownDto } from '../model/export-avanzato-data';

@Injectable({
  providedIn: 'root'
})
export class ExportAvanzatoService {

  private _http = inject(HttpClient);
  private export_avanzato_api: string = `${environment.baseUrl}/export-avanzato`;

  getIscrittiExport(data: ExportAvanzatoFilters): Observable<ExportAvanzatoListDto>{
    return this._http.post<ExportAvanzatoListDto>(`${this.export_avanzato_api}/lista-export`, data);
  }
  getFiltriAvanzatiExportDropdown(): Observable<FiltriAvanzatiExportDropdownDto>{
    return this._http.get<FiltriAvanzatiExportDropdownDto>(this.export_avanzato_api + `/dropdown-filtri-avanzati`);
  }

  esporta(data: ExportAvanzatoEsportazioneDto): Observable<any>{
    return this._http.post(`${this.export_avanzato_api}/esporta`, data, { responseType: 'blob' });
  }
}
